/**
 * Hook for integrating the Termly cookie consent banner.
 * This file provides functionality to add the Termly cookie consent banner
 * to web applications by injecting the necessary script into the DOM.
 */
import { useEffect } from "react";
import { userAgentIsSSR } from "../utils/userAgent";

/**
 * A hook that injects the Termly cookie consent banner script into the document.
 * Only runs on client-side (not during server-side rendering).
 *
 * The script provides GDPR and cookie law compliance functionality,
 * including cookie consent management and preference controls.
 *
 * @returns {void}
 */
export const useCookieBanner = () => {
  useEffect(() => {
    // Skip script injection during server-side rendering
    if (userAgentIsSSR()) return;

    // Create and configure the Termly script element
    const script = document.createElement("script");
    script.src =
      "https://app.termly.io/resource-blocker/e71a5f8a-441a-4239-aaca-66a74d03ce2d?autoBlock=on";
    script.type = "text/javascript";
    script.charset = "UTF-8";
    script.async = true;
    script.defer = true;

    // Inject the script into the document head
    document.head.appendChild(script);
  }, []);
};
